import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

export namespace ResetPassword {
  export type Input = void;

  export type Output = {
    passwordResetUrl: string;
  };

  export function useMutation() {
    const resetPassword = useInjectFeApiContext(
      FeApi.usersV1PasswordResetCreate,
    );
    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(): Promise<Output> {
        const result = await ok(resetPassword({}));
        return { passwordResetUrl: result.password_reset_url };
      },
    });
  }
}
